import React, { useContext } from 'react';
import { TableInstance } from 'react-table';
import MaterialPagination from '@mui/material/TablePagination';
import { TableContext } from '@particles';

//import {TableContext} from 'context';

export interface TableHeadProps {
  name: TableType;
  /** Table instance */
  tableInstance: TableInstance<TableRow>;
  /** Table pagination data, pagination will be disabled if not provided */
  pagination: Pagination;
  /** Rows per page options */
  rowsPerPageOptions: number[];
  /** Removes the ability to change page size */
  disablePageSize?: boolean;
  /** Called with the new perPage after the user picks a different rows-per-page
   *  value, so the parent can persist the choice. */
  onPerPageChange?: (perPage: number) => void;
}

export const TablePagination: React.FC<TableHeadProps> = ({
  name,
  tableInstance,
  pagination,
  rowsPerPageOptions,
  disablePageSize,
  onPerPageChange
}: TableHeadProps) => {
  const { setPageSize } = tableInstance;
  const {
    dispatch,
    state: {
      unifiedUsersPagination,
      coreAccountsPagination,
      coreContactsPagination,
      coreOfficesPagination,
      coreUsersPagination,
      teamPagination,
      billingPagination,
      accountPerformancePagination,
      billingAccountPagination,
      openAiPagination,
      twilioPagination,
      srtPagination,
      companyTransactionsLogsPagination,
      apiKeys,
      zazuAuditLogsPagination,
      artifactsPagination
    }
  } = useContext(TableContext);
  const { pageNumber: currentPage, pageSize: perPage, totalCount: total } = pagination;

  const handleChangePage = (
    _event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ): void => {
    if (name === 'unified-users') {
      dispatch({
        type: `set`,
        key: `unifiedUsersPagination`,
        value: { page: newPage + 1, perPage: unifiedUsersPagination.perPage }
      });
    } else if (name === 'core_accounts') {
      dispatch({
        type: `set`,
        key: `coreAccountsPagination`,
        value: { page: newPage + 1, perPage: coreAccountsPagination.perPage }
      });
    } else if (name === 'core_contacts') {
      dispatch({
        type: `set`,
        key: `coreContactsPagination`,
        value: { page: newPage + 1, perPage: coreContactsPagination.perPage }
      });
    } else if (name === 'core_users') {
      dispatch({
        type: `set`,
        key: `coreUsersPagination`,
        value: { page: newPage + 1, perPage: coreUsersPagination.perPage }
      });
    } else if (name === 'core_offices') {
      dispatch({
        type: `set`,
        key: `coreOfficesPagination`,
        value: { page: newPage + 1, perPage: coreOfficesPagination.perPage }
      });
    } else if (name === 'team') {
      dispatch({
        type: `set`,
        key: `teamPagination`,
        value: { page: newPage + 1, perPage: teamPagination.perPage }
      });
    } else if (name === 'billing') {
      dispatch({
        type: `set`,
        key: `billingPagination`,
        value: { page: newPage + 1, perPage: billingPagination.perPage }
      });
    } else if (name === 'account_performance') {
      dispatch({
        type: `set`,
        key: `accountPerformancePagination`,
        value: { page: newPage + 1, perPage: accountPerformancePagination.perPage }
      });
    } else if (name === 'billing-accounts') {
      dispatch({
        type: `set`,
        key: `billingAccountPagination`,
        value: { page: newPage + 1, perPage: billingAccountPagination.perPage }
      });
    } else if (name === 'open-ai') {
      dispatch({
        type: `set`,
        key: `openAiPagination`,
        value: { page: newPage + 1, perPage: openAiPagination.perPage }
      });
    } else if (name === 'twilio') {
      dispatch({
        type: `set`,
        key: `twilioPagination`,
        value: { page: newPage + 1, perPage: twilioPagination.perPage }
      });
    } else if (name === 'srt') {
      dispatch({
        type: `set`,
        key: `srtPagination`,
        value: { page: newPage + 1, perPage: srtPagination.perPage }
      });
    } else if (name === 'company-transactions-logs') {
      dispatch({
        type: `set`,
        key: `companyTransactionsLogsPagination`,
        value: { page: newPage + 1, perPage: companyTransactionsLogsPagination.perPage }
      });
    } else if (name === 'api-keys') {
      dispatch({
        type: `set`,
        key: `apiKeys`,
        value: { page: newPage + 1, perPage: apiKeys.perPage }
      });
    } else if (name === 'zazu-audit-logs') {
      dispatch({
        type: `set`,
        key: `zazuAuditLogsPagination`,
        value: { page: newPage + 1, perPage: zazuAuditLogsPagination.perPage }
      });
    } else if (name === 'artifacts') {
      dispatch({
        type: `set`,
        key: `artifactsPagination`,
        value: { page: newPage + 1, perPage: artifactsPagination.perPage }
      });
    }
  };

  const handleChangeRowsPerPage: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  > = (event) => {
    if (name === 'unified-users') {
      dispatch({
        type: `set`,
        key: `unifiedUsersPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else
    if (name === 'core_accounts') {
      dispatch({
        type: `set`,
        key: `coreAccountsPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'core_users') {
      dispatch({
        type: `set`,
        key: `coreUsersPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'core_contacts') {
      dispatch({
        type: `set`,
        key: `coreContactsPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'core_offices') {
      dispatch({
        type: `set`,
        key: `coreOfficesPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'team') {
      dispatch({
        type: `set`,
        key: `teamPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'billing') {
      dispatch({
        type: `set`,
        key: `billingPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'account_performance') {
      dispatch({
        type: `set`,
        key: `accountPerformancePagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'billing-accounts') {
      dispatch({
        type: `set`,
        key: `billingAccountPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'open-ai') {
      dispatch({
        type: `set`,
        key: `openAiPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'twilio') {
      dispatch({
        type: `set`,
        key: `twilioPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'srt') {
      dispatch({
        type: `set`,
        key: `srtPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'company-transactions-logs') {
      dispatch({
        type: `set`,
        key: `companyTransactionsLogsPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'api-keys') {
      dispatch({
        type: `set`,
        key: `apiKeys`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'zazu-audit-logs') {
      dispatch({
        type: `set`,
        key: `zazuAuditLogsPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    } else if (name === 'artifacts') {
      dispatch({
        type: `set`,
        key: `artifactsPagination`,
        value: { page: 1, perPage: Number(event.target.value) }
      });
    }
    setPageSize(Number(event.target.value));
    onPerPageChange?.(Number(event.target.value));
  };

  return (
    <MaterialPagination
      component="div"
      rowsPerPageOptions={disablePageSize ? [] : rowsPerPageOptions}
      colSpan={3}
      count={total}
      rowsPerPage={perPage}
      page={currentPage - 1}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}

      // ActionsComponent={TablePaginationActions}
    />
  );
};

export default TablePagination;
